#@import Booking.Models.Base
#@export Booking.Models.Attribute

class Booking.Models.Attribute extends Booking.Models.Base

  getLabel: ->
    @get('label')

  getName: ->
    @get('name')

  getType: ->
    @get('type')

  getValidation: ->
    @get('validation') or false

  isRequired: ->
    true # API does not return that flag as it should yet

  validate: (value) ->
    value.match(@getValidation())?

  isPhone: ->
    @getName() is 'phone_number'

  isTextNotifications: ->
    @getName() is 'text_notifications'

  isPartySize: ->
    @getName() is 'party_size'

  isQuestion: ->
    @getType() is 'question'

  allowedValues: ->
    values = @getType().match(/^enumeration\((.*)\)$/)?[1]?.split(';')

    if @isPartySize()
      _.map values, (value) -> parseInt(value, 10)
    else
      values
